import {
  IConstReducer,
  IGetFilterReferencesActionFulfilled,
  IGetFilterReferencesActionRejected,
  IGetFilterReferencesListAction,
  IGetAdditionalCommentsLimitActionFulfilled,
  IGetAdditionalCommentsLimitActionRejected,
  IGetAdditionalCommentsLimitAction
} from "../types";

const initialState: IConstReducer = {
  filterReferences: {
    data: { countries: [], teams: [], contractTitles: [], departments: [], tenures: [], supervisors: [] },
    completed: false,
    pending: true,
    rejected: false
  },
  additionalCommentsLimit: {
    data: { additionalCommentsLimit: 0 },
    completed: false,
    pending: true,
    rejected: false
  }
};

// TODO - this will be a persisten redux store for keeping data we need once

type Action =
  | IGetFilterReferencesListAction
  | IGetFilterReferencesActionFulfilled
  | IGetFilterReferencesActionRejected
  | IGetAdditionalCommentsLimitAction
  | IGetAdditionalCommentsLimitActionFulfilled
  | IGetAdditionalCommentsLimitActionRejected;

export const constReducer = (state = initialState, action: Action): IConstReducer => {
  switch (action.type) {
    case "GET_FILTER_REFERENCES":
      return {
        ...state,
        filterReferences: {
          completed: false,
          data: { countries: [], teams: [], contractTitles: [], departments: [], tenures: [], supervisors: [] },
          pending: true,
          rejected: false
        }
      };
    case "GET_FILTER_REFERENCES_FULFILLED":
      return {
        ...state,
        filterReferences: { completed: true, data: action.payload, pending: false, rejected: false }
      };
    case "GET_FILTER_REFERENCES_REJECTED":
      return {
        ...state,
        filterReferences: {
          completed: true,
          data: { countries: [], teams: [], contractTitles: [], departments: [], tenures: [], supervisors: [] },
          pending: false,
          rejected: true
        }
      };
    case "GET_ADDITIONAL_COMMENTS_LIMIT":
      return {
        ...state,
        additionalCommentsLimit: {
          completed: false,
          data: { additionalCommentsLimit: 0 },
          pending: true,
          rejected: false
        }
      };
    case "GET_ADDITIONAL_COMMENTS_LIMIT_FULFILLED":
      return {
        ...state,
        additionalCommentsLimit: { completed: true, data: action.payload, pending: false, rejected: false }
      };
    case "GET_ADDITIONAL_COMMENTS_LIMIT_REJECTED":
      return {
        ...state,
        additionalCommentsLimit: {
          completed: true,
          data: { additionalCommentsLimit: 0 },
          pending: false,
          rejected: true
        }
      };
    default:
      return state;
  }
};
